import { render } from "./CardClient.vue?vue&type=template&id=6e9aa4b0"
import script from "./CardClient.vue?vue&type=script&lang=js"
export * from "./CardClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__